import { BrowserRouter, Route, Switch } from "react-router-dom"
import { ThemeProvider } from "@stackup/inputs"
import { theme } from "~/forms"
import { Main } from "./components/Main"
import { Navigation } from "./components/Navigation"
import { routes } from "./routes"
import HomePage from "./routes/HomePage.mdx"

const App = () => (
  <ThemeProvider value={theme}>
    <BrowserRouter>
      <div className="min-h-screen">
        <a href="#main-content" className="skip-message message">
          <p>Go to main content</p>
        </a>
        <Navigation className="menu-panel" />
        <Main className="content-panel" id="main-content">
          <Switch>
            <Route exact path="/" component={HomePage} />

            {routes.map(({ items, route: sectionRoute }) =>
              items.map(({ title, component, route }) => (
                <Route
                  key={title}
                  path={`/${sectionRoute}/${route}`}
                  component={component}
                />
              ))
            )}
          </Switch>
        </Main>
      </div>
    </BrowserRouter>
  </ThemeProvider>
)

export default App
